import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { CompanyStoreSetting } from "~/models/CompanyStoreSetting";

const paths = {
	index: "/company_store_settings"
};

type TIndex = () => SwrReturnType<CompanyStoreSetting[]>;
type ReturnType = {
	index: TIndex;
};

export const useCompanyStoreSettings = (): ReturnType => {
	const index: TIndex = () => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error } = useSWR<CompanyStoreSetting[]>(paths.index);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			mutate: mutate ?? null
		};
	};
	return { index };
};
